import type { Components } from 'react-markdown';
import MermaidBlock from './MermaidBlock';

export const markdownComponents: Components = {
  code({ className, children, ...props }) {
    const match = /language-(\w+)/.exec(className || '');
    const lang = match?.[1];
    const code = String(children).replace(/\n$/, '');

    if (lang === 'mermaid') {
      return <MermaidBlock code={code} />;
    }

    // Inline code (no language class and not inside a pre)
    return (
      <code className={className} {...props}>
        {children}
      </code>
    );
  },
};
